<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="6">
                    <ValidationProvider name="day_part" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('day_part')">
                            <ParameterSelectbox code="session_day_parts" v-model="form.day_part" :validate-error="errors[0]">
                            </ParameterSelectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="day_type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('day_type')">
                            <ParameterSelectbox code="session_day_types" v-model="form.day_type" :validate-error="errors[0]">
                            </ParameterSelectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col v-show="!isYouthProgram" cols="6">
                    <ValidationProvider name="module_date_id" :rules="!isYouthProgram ? 'required' : ''" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('module_date')">
                            <module-date-selectbox ref="moduleDate" v-model="form.module_date_id" :validate-error="errors[0]">
                            </module-date-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
              <b-col cols="6">
                <ValidationProvider name="program_code" rules="required" v-slot="{ valid, errors }">
                  <b-form-group :label="$t('program')">
                    <program-selectbox level="E" :validate-error="errors[0]" v-model="form.program_code"></program-selectbox>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col cols="6">
                <ValidationProvider name="course_id" rules="required" v-slot="{ valid, errors }">
                  <b-form-group :label="$t('course')">
                    <esl-course-selectbox
                        :validate-error="errors[0]"
                        :is-program-code-required="true"
                        :program-code="form.program_code"
                        v-model="form.course_id"></esl-course-selectbox>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col cols="6">
                <ValidationProvider name="section" rules="required" v-slot="{ valid, errors }">
                  <b-form-group :label="$t('section')">
                    <b-form-input type="number" v-model="form.section"
                                  :validateError="errors[0]"/>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
                <b-col cols="6">
                    <ValidationProvider name="start_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('start_date')">
                            <select-date
                                v-model="form.start_date"
                                :is-time="false"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="end_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('end_date')">
                            <select-date
                                v-model="form.end_date"
                                :is-time="false"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="instructor_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('teaching_staff')">
                            <staff-auto-complete v-model="form.instructor_id"
                                                 :valueObject="instructorValueObject"
                                                 :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="start_time" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('start_time')">
                            <b-form-input
                                type="time"
                                v-model="form.start_time"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="end_time" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('end_time')">
                            <b-form-input
                                type="time"
                                v-model="form.end_time"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col v-show="!isYouthProgram" cols="6">
                    <ValidationProvider name="evaluation_id" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('evaluation')">
                            <evaluation-selectbox v-model="form.evaluation_id"></evaluation-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="classroom_id" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('classroom')">
                            <classroom-selectbox v-model="form.classroom_id" :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="quota" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('quota')">
                            <b-form-input type="number" v-model="form.quota "
                                          :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="student_number" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('student_numbers')">
                            <lined-textarea v-model="student_numbers"
                                            :nowrap="false"
                                            :disabled="false"
                                            :styles="{ height: '10em', resize: 'both' }"
                                            :validateError="errors[0]">
                            </lined-textarea>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="class_modality" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('class_modality')">
                            <parameter-selectbox v-model="form.class_modality"
                                                 :validate-error="errors[0]"
                                                 code="session_class_modalities"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-row v-if="isYouthProgram">
                <b-col cols="6">
                    <ValidationProvider name="days_in_a_week" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('days_in_a_week')">
                            <ParameterSelectbox
                                v-model="form.days_in_a_week"
                                code="days_in_a_week"
                                sort="rank"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="days_of_the_week" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('days_of_the_week')">
                            <ParameterSelectbox
                                v-model="form.days_of_the_week"
                                :multiple="true"
                                code="days"
                                sort="code"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="hours_in_a_day" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('hours_in_a_day')">
                            <b-form-input type="number" v-model="form.hours_in_a_day" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="hours_in_a_day_for_attendance" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('hours_in_a_day_for_attendance')">
                            <b-form-input type="number" v-model="form.hours_in_a_day_for_attendance" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('part_of_the_day')">
                        <ValidationProvider name="part_of_the_day" rules="required" v-slot="{ errors }">
                            <ParameterSelectbox
                                v-model="form.part_of_the_day"
                                code="part_of_the_day"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import SessionService from "@/services/SessionService";
//Components
import EvaluationSelectbox from "@/components/interactive-fields/EvaluationSelectbox.vue";
import EslCourseSelectbox from "@/components/interactive-fields/EslCourseSelectbox.vue";
import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox.vue";
import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete";
import LinedTextarea from "../../../components/elements/LinedTextarea.vue";
import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';


export default {
    components: {
        ModuleDateSelectbox,
        LinedTextarea,
        ClassroomSelectbox,
        ValidationProvider,
        ValidationObserver,
        EvaluationSelectbox,
        EslCourseSelectbox,
        StaffAutoComplete,
        ParameterSelectbox
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            student_numbers:"",
            formLoading: false,
            form: {
                program_code: null,
                module_date_id: null,
                course_id: null,
                start_date: null,
                end_date: null,
                start_time: null,
                end_time: null,
                evaluation_id: null,
                classroom_id: null,
                class_modality: null,
                instructor_id: null,
                quota: null,
                section: null,
            },
            instructorValueObject: {},
        }
    },
    computed: {
        isYouthProgram() {
            return this.form.program_code === '0702004';
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            this.formLoading = true;
            SessionService.get(id)
                .then((response) => {
                    this.form = response.data.data;
                    if (this.form.student_numbers && Array.isArray(this.form.student_numbers)) {
                        this.student_numbers = this.form.student_numbers.join("\n");
                    }
                    this.instructorValueObject = {
                        value: this.form.instructor_id,
                        text: this.form.instructor_name + ' ' + this.form.instructor_surname
                    }
                })
                .catch((error) => {
                    if (error.data.message) {
                        this.$toast.error(this.$t("api." + error.data.message));
                    }
                }).finally(() => {
                this.formLoading = false;
            });
        },
        async updateForm() {
            if (this.checkPermission('session_update')) {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;

                    if (this.student_numbers && this.student_numbers !== null) {
                        let student_numbers = this.student_numbers.split("\n")
                        this.form.student_numbers = student_numbers

                    }

                    let payload = { ...this.form };

                    if (!this.isYouthProgram) {
                        delete payload.days_in_a_week;
                        delete payload.days_of_the_week;
                        delete payload.hours_in_a_day;
                        delete payload.hours_in_a_day_for_attendance;
                        delete payload.part_of_the_day;
                    } else {
                        delete payload.module_date_id;
                        delete payload.evaluation_id;
                    }
                    SessionService.update(this.formId, payload)
                        .then((response) => {
                            this.formLoading = false;
                            this.$toast.success(this.$t("api." + response.data.message));
                            this.$emit("updateFormSuccess")
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate)
                        }).finally(() => {
                        this.formLoading = false;
                    })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>
